// extracted by mini-css-extract-plugin
export default {"documentSourcesHeader":"HAB7BbT","sourcesList":"kvRZ5IU","metadataEntry":"CaZ2XYc"};